<template>
  <div class="cost">
    <header-back
      :title="costTit"
      @back="toBack"
    />
    <cube-scroll
      ref="costScroll"
      :data="originCostIndexData"
    >
      <div
        v-if="originCostIndexData.length === 0 && !loadingContent"
        class="empty-pro-box"
      >
        <img
          :src="noDataImage"
        >
        <span class="empty_text"> {{ $t('message["173"]') }}</span>
      </div>
      <template
        v-for="(item, index) in originCostIndexData"
        v-else
      >
        <const-main
          :key="index"
          :title="item.year"
          :list="item.list"
        />
      </template>
      <cube-loading
        v-if="loadingContent"
        :size="40"
      />
    </cube-scroll>
  </div>
</template>

<script type="text/ecmascript-6">
import constMain from './components/CostMain'
import headerBack from '@/components/mobile/HeaderBack'
import noDataImage from '@/assets/images/empty.png'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    constMain,
    headerBack
  },
  data () {
    return {
      originCostIndexData: [],
      noDataImage
    }
  },
  computed: {
    ...mapState('costMaintain/costIndexData', ['costIndexData', 'loadingContent']),
    ...mapState(['baseinfo']),
    costTit () {
      return this.$t('message["105"]')
    }
  },
  watch: {
    costIndexData (newValue) {
      this.originCostIndexData = this.formatCostIndexData(newValue)
    },
    baseinfo (newVal) {
      document.title = this.$t('message["105"]') + ' - ' + newVal.projectname + '-' + newVal.comname
    }
  },
  created () {
    this.fetchGetCostIndex()
  },
  methods: {
    ...mapActions('costMaintain/costIndexData', ['fetchGetCostIndex']),
    // 规范化首页数据
    formatCostIndexData (value) {
      let snapCostData = []
      if (JSON.stringify(value) !== {}) {
        for (let key in value) {
          snapCostData.push({ year: key, list: value[key] })
        }
        return snapCostData
      }
    },
    toBack () {
      this.$router.push({ name: 'ProjectIndex' })
    }
  }
}
</script>

<style scoped lang="scss">
.cost {
  margin-top: 20px;
  .empty-pro-box {
    width:273px;
    margin: 130px auto 0;
    text-align: center;
    img{
      width: 273px;
      height: 205px;
    }
    .empty_text {
      color: rgb(179,179,179);
    }
  }
}
</style>
